import React, { useState, useEffect, useContext } from "react";
import Notification from "../Notification/Notification";
import Profile from "../../assets/Images/person.jpg";
import Button from "../elements/Button/Button";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";

export default function ManageWorkspace() {
  const [workspacelist, setWorkspacelist] = useState([]);
  const [notification, setNotification] = useState({ message: "", type: "" });
  const { token } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    getWorkspace();
  }, []);

  const getWorkspace = async () => {
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/company/fetchWorkspace`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      });
      const data = await response.json();

      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          data.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      if (decryptedData) {
        setWorkspacelist(decryptedData);
        console.log("manage workspace", decryptedData);
        console.log("checking process", process.env);
      }
    } catch (error) {
      console.error("Error:", error);
      showNotification("Something went wrong.", "error");
    }
  };

  const handleWorkspaceClick = (workspace) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the workspace?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, cancel!",
    }).then(async (swalResult) => {
      if (swalResult.isConfirmed) {
        const { workspace_id, email, company_id, name } = workspace;

        const workspaceData = { workspace_id, email };

        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(workspaceData),
          process.env.REACT_APP_SECRETKEY
        ).toString();

        const requestData = { data: encryptedData };

        try {
          const serverURL = process.env.REACT_APP_SERVER_URL;
          const response = await fetch(
            `${serverURL}/company/updateActiveWorkspace`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                token: token,
              },
              body: JSON.stringify(requestData),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to update workspace");
          }

          const result = await response.json();

          const decryptedData = JSON.parse(
            CryptoJS.AES.decrypt(
              result.data,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );

          if (decryptedData.message) {
            Swal.fire("Changed!", decryptedData.message, "success").then(() => {
              const encryptedMetadata = localStorage.getItem("metadata");
              if (encryptedMetadata) {
                const decryptedMetadata = JSON.parse(
                  CryptoJS.AES.decrypt(
                    encryptedMetadata,
                    process.env.REACT_APP_SECRETKEY
                  ).toString(CryptoJS.enc.Utf8)
                );

                decryptedMetadata.cid = company_id;
                decryptedMetadata.company_name = name;

                const encryptedCID = CryptoJS.AES.encrypt(
                  JSON.stringify(decryptedMetadata),
                  process.env.REACT_APP_SECRETKEY
                ).toString();

                localStorage.setItem("metadata", encryptedCID);
                navigate("/Dashboard");
              }
            });
          } else {
            Swal.fire(
              "Error!",
              "Something went wrong. Please try again.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error:", error);
          Swal.fire("Error!", "An unexpected error occurred.", "error");
        }
      }
    });
  };

  const goToWorkspaceCreate = () => {
    navigate("/AddCompany");
  };

  const showNotification = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 3000); // Auto-hide after 3 seconds
  };

  const renderWorkspaces = (status) => {
    const [showMenu, setShowMenu] = useState(null);

    const filteredWorkspaces = workspacelist.filter(
      (workspace) => workspace.status === status
    );

    const isActiveWorkspace = (workspace) => {
      const encryptedMetadata = localStorage.getItem("metadata");
      if (encryptedMetadata) {
        try {
          const decryptedMetadata = JSON.parse(
            CryptoJS.AES.decrypt(
              encryptedMetadata,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );
          return decryptedMetadata.cid === workspace.company_id;
        } catch (error) {
          console.error("Error checking active workspace:", error);
          return false;
        }
      }
      return false;
    };

    const handleMenuClick = (workspace_id) => {
      setShowMenu((prev) => (prev === workspace_id ? null : workspace_id));
    };

    const handleInactivateClick = (workspace) => {
      setShowMenu(false);

      const encryptedMetadata = localStorage.getItem("metadata");

      if (encryptedMetadata) {
        const decryptedMetadata = JSON.parse(
          CryptoJS.AES.decrypt(
            encryptedMetadata,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );

        if (decryptedMetadata.cid === workspace.company_id) {
          Swal.fire({
            title: "Error!",
            text: `The workspace '${workspace.name}' is currently active. Please change the workspace before archiving it.`,
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }
      }

      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to Archive the workspace "${workspace.name}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, archive it!",
        cancelButtonText: "No, cancel!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await updateWorkspaceStatus(workspace, "archive");
          Swal.fire("Archived!", "The workspace has been archived.", "success");
        } else {
          Swal.fire("Cancelled", "The workspace was not archived.", "info");
        }
      });
    };

    const handleUnarchiveClick = (workspace) => {
      setShowMenu(false);

      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to Unarchive the workspace "${workspace.name}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, unarchive it!",
        cancelButtonText: "No, cancel!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await updateWorkspaceStatus(workspace, "active");
          Swal.fire(
            "Unarchived!",
            "The workspace has been unarchived.",
            "success"
          );
        } else {
          Swal.fire("Cancelled", "The workspace was not unarchived.", "info");
        }
      });
    };

    const updateWorkspaceStatus = async (workspace, newStatus) => {
      const { workspace_id } = workspace;
      const workspaceData = { status: newStatus, workspace_id };
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(workspaceData),
        process.env.REACT_APP_SECRETKEY
      ).toString();

      const requestData = { data: encryptedData };

      try {
        const serverURL = process.env.REACT_APP_SERVER_URL;
        const response = await fetch(
          `${serverURL}/company/updateWorkSpaceStatus`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
            body: JSON.stringify(requestData),
          }
        );

        const result = await response.json();
        if (response.ok && result.data) {
          const decryptedData = JSON.parse(
            CryptoJS.AES.decrypt(
              result.data,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );

          getWorkspace();
        } else {
          throw new Error(`Failed to ${newStatus} workspace`);
        }
      } catch (error) {
        console.error(`Error ${newStatus} workspace:`, error);
        Swal.fire(
          "Error!",
          `An unexpected error occurred while updating the workspace status.`,
          "error"
        );
      }
    };

    var workspace_length = filteredWorkspaces.length;
    return filteredWorkspaces.length > 0
      ? filteredWorkspaces.map((workspace) => {
          const isActive = isActiveWorkspace(workspace);
          return (
            <div
              key={workspace.workspace_id}
              className={`p-4 sm:p-6 md:p-8 rounded-lg sm:rounded-xl md:rounded-2xl text-center bg-white text-gray-600 shadow-sm hover:shadow-md transition-all duration-300 w-full relative min-h-[160px] sm:min-h-[180px] flex flex-col justify-between ${
                isActive ? "ring-2 ring-green-500 ring-opacity-50" : ""
              }`}
            >
              <div className="flex justify-between items-start mb-3 sm:mb-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-md border border-gray-200 flex-shrink-0 overflow-hidden">
                  {workspace.profile ? (
                    <img
                      src={`${process.env.REACT_APP_SERVER_BASEURL}/companyprofile/${workspace.profile}`}
                      className="w-full h-full object-cover"
                      alt="Profile"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                      <svg
                        className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  )}
                </div>

                <div
                  className="w-8 h-8 sm:w-9 sm:h-9 bg-green-50 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-100 transition-colors flex-shrink-0"
                  onClick={() => handleMenuClick(workspace.workspace_id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="w-4 h-4 fill-gray-700"
                  >
                    <circle cx="5" cy="12" r="2"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                    <circle cx="19" cy="12" r="2"></circle>
                  </svg>
                </div>

                {showMenu === workspace.workspace_id && (
                  <div className="absolute top-10 sm:top-12 right-1 z-50 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="text-sm text-gray-700">
                      {workspace.status === "archive" ? (
                        <button
                          onClick={() => handleUnarchiveClick(workspace)}
                          className="block px-3 py-1.5 text-green-600 hover:bg-gray-50 w-full text-center transition-colors rounded-md whitespace-nowrap"
                        >
                          Unarchive
                        </button>
                      ) : workspace_length > 1 ? (
                        <button
                          onClick={() => handleInactivateClick(workspace)}
                          className="block px-3 py-1.5 text-red-500 hover:bg-gray-50 w-full text-center transition-colors rounded-md whitespace-nowrap"
                        >
                          Archive
                        </button>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>

              <div className="flex-1 mb-3 sm:mb-4">
                <div className="text-left mb-2 sm:mb-3">
                  <h3 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 leading-tight truncate">
                    {workspace.name || "Unnamed Workspace"}
                  </h3>
                </div>
                <hr className="border-gray-200" />
              </div>

              <div className="mt-auto">
                {workspace.status === "archive" ? (
                  <div className="inline-flex items-center justify-center font-medium text-gray-400 text-sm sm:text-base cursor-not-allowed py-2">
                    Archived
                  </div>
                ) : isActive ? (
                  <div className="inline-flex items-center justify-center font-semibold text-green-700 text-sm sm:text-base cursor-default py-2 px-4 rounded-md bg-green-50 border border-green-200">
                    ✓ Active
                  </div>
                ) : (
                  <button
                    className="inline-flex items-center justify-center font-medium text-white bg-green-600 hover:bg-green-700 text-sm sm:text-base cursor-pointer transition-all duration-200 py-2 px-6 rounded-md shadow-sm hover:shadow-md active:transform active:scale-95"
                    onClick={() => handleWorkspaceClick(workspace)}
                  >
                    Select
                  </button>
                )}
              </div>

              {/* Active Workspace Indicator */}
              {isActive && (
                <div className="absolute bottom-2 right-2 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-sm"></div>
              )}
            </div>
          );
        })
      : null;
  };

  const archivedWorkspaces = renderWorkspaces("archive");

  return (
    <div className="flex flex-col gap-4 sm:gap-6 mx-2 sm:mx-4 md:mx-5 p-3 sm:p-4 md:p-5 bg-white bg-opacity-50 rounded-t-xl sm:rounded-t-2xl h-full min-h-screen">
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: "", type: "" })}
      />

      <div className="flex items-center justify-center py-2 sm:py-4">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">
          Manage Workspaces
        </h2>
      </div>

      {/* Active Workspaces */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6 w-full">
        {renderWorkspaces("active")}
      </div>

      {archivedWorkspaces && (
        <>
          <div className="flex items-start justify-start py-2 mt-3 sm:mt-5 text-base sm:text-lg font-bold text-gray-900">
            Archived Workspaces
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6 w-full opacity-60">
            {archivedWorkspaces}
          </div>
        </>
      )}

      <div
        className="flex justify-center sm:justify-end mt-6 sm:mt-8"
        onClick={goToWorkspaceCreate}
      >
        <Button
          className="border-[1px] !border-green-700 !bg-transparent !rounded-full px-4 sm:px-6 py-2 sm:py-3 text-green-700 text-sm sm:text-base hover:bg-green-50 transition-colors w-full sm:w-auto"
          type="button"
        >
          Create +
        </Button>
      </div>
    </div>
  );
}
